











 


























































const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigableByFacilitator",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorStageId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigable",
  "storageKey": null
},
v7 = [
  (v0/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "phases",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "stages",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isComplete",
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v8 = {
  "kind": "InlineDataFragmentSpread",
  "name": "fromStageIdToUrl_meeting",
  "selections": (v7/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v9 = {
  "kind": "InlineDataFragmentSpread",
  "name": "updateLocalStage_meeting",
  "selections": (v7/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v10 = [
  (v0/*: any*/)
],
v11 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "stages",
    "plural": true,
    "selections": (v10/*: any*/),
    "storageKey": null
  }
],
v12 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localStage",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localPhase",
      "plural": false,
      "selections": (v11/*: any*/),
      "storageKey": null
    }
  ]
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryString",
  "storageKey": null
},
v14 = [
  (v13/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdatePokerScopeMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EstimateStage",
      "kind": "LinkedField",
      "name": "newStages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useMakeStageSummaries_stages"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PokerEstimateHeaderCard_stage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PokerCardDeckStage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EstimatePhaseAreaStage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JiraFieldDimensionDropdown_stage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EstimateDimensionColumn_stage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EstimatePhaseDiscussionDrawerEstimateStage"
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVoting",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TemplateDimensionRef",
          "kind": "LinkedField",
          "name": "dimensionRef",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TemplateScaleRef",
              "kind": "LinkedField",
              "name": "scale",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TemplateScaleValue",
                  "kind": "LinkedField",
                  "name": "values",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "color",
                      "storageKey": null
                    },
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ServiceField",
          "kind": "LinkedField",
          "name": "serviceField",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EstimateUserScore",
          "kind": "LinkedField",
          "name": "scores",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userId",
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stageId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "picture",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "preferredName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PokerMeeting",
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PokerMeeting_meeting"
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "useInitialSafeRoute_meeting",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v8/*: any*/),
                (v9/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "meetingType",
                  "storageKey": null
                },
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "facilitatorUserId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "phases",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "stages",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v6/*: any*/),
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v12/*: any*/)
              ],
              "type": "NewMeeting",
              "abstractKey": "__isNewMeeting"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "useUpdatedSafeRoute_meeting",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v8/*: any*/),
                (v9/*: any*/),
                (v0/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "phases",
                  "plural": true,
                  "selections": (v11/*: any*/),
                  "storageKey": null
                },
                (v12/*: any*/)
              ],
              "type": "NewMeeting",
              "abstractKey": "__isNewMeeting"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "phases",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EstimateStage",
                  "kind": "LinkedField",
                  "name": "stages",
                  "plural": true,
                  "selections": (v10/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "EstimatePhase",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GitLabSearchQuery",
              "kind": "LinkedField",
              "name": "gitlabSearchQuery",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "selectedProjectsIds",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GitHubSearchQuery",
              "kind": "LinkedField",
              "name": "githubSearchQuery",
              "plural": false,
              "selections": (v14/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraSearchQuery",
              "kind": "LinkedField",
              "name": "jiraSearchQuery",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectKeyFilters",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ParabolSearchQuery",
              "kind": "LinkedField",
              "name": "parabolSearchQuery",
              "plural": false,
              "selections": (v14/*: any*/),
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UpdatePokerScopeSuccess",
  "abstractKey": null
};
})();

(node ).hash = "0addd561049cfea118595533f2a4f0bf";

export default node;
